/*
 * Copyright (c) 2022. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import addressTranslations from "./addressTranslations";
import organizationEmailTranslations from "./organizationEmailTranslations";

const organizationTranslations = {
  name: {
    label: "Name",
  },
  legalName: {
    label: "Firma",
    question: "Wie lautet der Name des Unternehmens?",
  },
  telephone: {
    label: "Telefonnummer",
  },
  fax: {
    label: "Faxnummer",
  },
  beaSafeId: {
    label: "beA-Adresse",
  },
  mainEmail: organizationEmailTranslations,
  address: addressTranslations,
};

export default organizationTranslations;
